export const galabauSubmenuData = (windowWidth) =>
  windowWidth >= 1024
    ? [
        {
          type: "SubmenuLink",
          label: "Nachrichten",
          link: "/fachzeitschriften/galabau/nachrichten",
        },

        {
          type: "SubmenuLink",
          label: "Maschinen und Geräte",
          link: "/fachzeitschriften/galabau/maschinen",
        },
        {
          type: "SubmenuLink",
          label: "Baupraxis",
          link: "/fachzeitschriften/galabau/baupraxis",
        },
        {
          type: "SubmenuLink",
          label: "Baumpflege",
          link: "/fachzeitschriften/galabau/baumpflege",
        },
        {
          type: "SubmenuLink",
          label: "Kommunaltechnik",
          link: "/fachzeitschriften/galabau/kommunaltechnik",
          additional_classes: ["is-hidden-until-widescreen-flex"],
        },
        {
          type: "SubmenuLink",
          label: "Stadtgrün",
          link: "/fachzeitschriften/galabau/stadtgruen",
          additional_classes: ["is-hidden-until-fullhd-flex"],
        },
        {
          type: "DropdownMenu",
          label: "mehr",
          page: "galabau",
          dropdown_menu_items: [
            {
              type: "",
              label: "Kommunaltechnik",
              link: "/fachzeitschriften/galabau/kommunaltechnik",
              additional_classes: ["is-hidden-widescreen"],
            },
            {
              type: "SubmenuLink",
              label: "Stadtgrün",
              link: "/fachzeitschriften/galabau/stadtgruen",
              additional_classes: ["is-hidden-fullhd"],
            },
            {
              type: "SubmenuLink",
              label: "Baustoffe und Bauprodukte",
              link: "/fachzeitschriften/galabau/baustoffe",
            },
            {
              type: "SubmenuLink",
              label: "Gartengestaltung",
              link: "/fachzeitschriften/galabau/gartengestaltung",
            },
            {
              type: "SubmenuLink",
              label: "Areal- und Rasenpflege",
              link: "/fachzeitschriften/galabau/rasenpflege",
            },
            {
              type: "SubmenuLink",
              label: "Nutzfahrzeuge",
              link: "/fachzeitschriften/galabau/nutzfahrzeuge",
            },
            {
              type: "SubmenuLink",
              label: "Regenwassermanagement",
              link: "/fachzeitschriften/galabau/regenwasser",
            },
            {
              type: "SubmenuLink",
              label: "Branchensoftware",
              link: "/fachzeitschriften/galabau/software",
            },
          ],
        },
        {
          type: "SubmenuSpacer",
        },
        {
          type: "SubmenuLink",
          label: "Jobs",
          link: "/fachzeitschriften/jobs-in-der-bauwirtschaft",
        },
        {
          type: "SubmenuSpacer",
        },
        {
          type: "BfzLogo",
          link: "/fachzeitschriften/galabau",
          page: "galabau",
          width: "115px",
          height: "32px",
          title: "B_I galabau Logo",
        },
      ]
    : [
        {
          type: "DropdownMenuMobile",
          label: "Themen",
          page: "galabau",
          dropdown_menu_items: [
            {
              type: "SubmenuLink",
              label: "Nachrichten",
              link: "/fachzeitschriften/galabau/nachrichten",
            },

            {
              type: "SubmenuLink",
              label: "Maschinen und Geräte",
              link: "/fachzeitschriften/galabau/maschinen",
            },
            {
              type: "SubmenuLink",
              label: "Baupraxis",
              link: "/fachzeitschriften/galabau/baupraxis",
            },
            {
              type: "SubmenuLink",
              label: "Baumpflege",
              link: "/fachzeitschriften/galabau/baumpflege",
            },
            {
              type: "",
              label: "Kommunaltechnik",
              link: "/fachzeitschriften/galabau/kommunaltechnik",
            },
            {
              type: "SubmenuLink",
              label: "Stadtgrün",
              link: "/fachzeitschriften/galabau/stadtgruen",
            },
            {
              type: "SubmenuLink",
              label: "Baustoffe und Bauprodukte",
              link: "/fachzeitschriften/galabau/baustoffe",
            },
            {
              type: "SubmenuLink",
              label: "Gartengestaltung",
              link: "/fachzeitschriften/galabau/gartengestaltung",
            },
            {
              type: "SubmenuLink",
              label: "Areal- und Rasenpflege",
              link: "/fachzeitschriften/galabau/rasenpflege",
            },
            {
              type: "SubmenuLink",
              label: "Nutzfahrzeuge",
              link: "/fachzeitschriften/galabau/nutzfahrzeuge",
            },
            {
              type: "SubmenuLink",
              label: "Regenwassermanagement",
              link: "/fachzeitschriften/galabau/regenwasser",
            },
            {
              type: "SubmenuLink",
              label: "Branchensoftware",
              link: "/fachzeitschriften/galabau/software",
            },
          ],
        },
        {
          type: "BfzLogo",
          link: "/fachzeitschriften/galabau",
          page: "galabau",
          width: "115px",
          height: "32px",
          title: "B_I galabau Logo",
        },
      ]
